export default __webpack_public_path__ + "static/media/painting19.b9044aea.jpg";